// src/services/AdminService.js

import { API_BASE_URL } from '../utils/constants';
import axiosInstance from './axiosInstance';

// User Authentication API functions
export const RoleService = {

	getRoles: async () => {
		try {
			const response = await axiosInstance.get(`${API_BASE_URL}/role`);
			const data = await response.data;

			return {
				status: response.status,
				data: data
			};
		} catch (error) {
			throw error;
		}
	},
};
